import { render, staticRenderFns } from "./pointOrder.vue?vue&type=template&id=96a7c4b4&scoped=true&"
import script from "./pointOrder.vue?vue&type=script&lang=js&"
export * from "./pointOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a7c4b4",
  null
  
)

export default component.exports